import React from 'react';

import { FormTextField } from '../../../../components';

export const FilterByName = (props) => (
  <FormTextField
    {...props}
    id="app-apiproducts-filter-by-name"
    data-apim-test="app-apiproducts-filter-by-name"
  />
);
